import Link from 'next/link'
import {useParams} from 'next/navigation'
import {useCallback} from 'react'

import {IconArrowRightExtraBold} from '@defign/asset'
import {Action, sendAULog} from '@financial/common-logs'
import {useQuery} from '@tanstack/react-query'
import classNames from 'classnames/bind'

import {INTERNAL_ROUTES} from '$constants/internal-routes'
import {getContentsQuery} from '$queries/insurance/contentQuery'
import {sendClickNlog} from '$utils/nlog'

import Styles from './InsuranceRecommendContent.module.scss'

const cx = classNames.bind(Styles)

export default function InsuranceRecommendContent() {
    const {id} = useParams<{id: string}>()

    const {data: recommendedContents} = useQuery(
        getContentsQuery.query({
            params: {onlyRecommend: true, contentId: +id},
        }),
    )

    const handleClick = useCallback(() => {
        sendClickNlog('insutipdetail.recomm')
        sendAULog({page: 'insu', area: 'D', service: 'md', code: 'insu_tip_detail_related'}, Action.Click)
    }, [])

    return (
        <div className={cx('article')}>
            <h3 className={cx('title')}>관련 추천 컨텐츠</h3>
            <div className={cx('recommend-area')}>
                <ul>
                    {recommendedContents?.map(({contentsSeqno, title, keyword: keywords}) => (
                        <li key={contentsSeqno} className={cx('item')}>
                            <Link
                                href={{
                                    pathname: INTERNAL_ROUTES['INSURANCE_CONTENTS_[ID]'],
                                    query: {id: contentsSeqno},
                                }}
                                className={cx('link')}
                                onClick={handleClick}
                            >
                                <strong className={cx('main-text')}>{title}</strong>
                                <div className={cx('keyword')}>
                                    <strong className="blind">키워드 목록</strong>
                                    <ul>
                                        {keywords.map((keyword) => (
                                            <li key={keyword} className={cx('tag')}>
                                                #{keyword}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <IconArrowRightExtraBold width={9} height={12} fill="#1e1e23" />
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}
